import { Tooltip } from '@mui/material';
import type {
  ComplianceStatus,
  ConfigurationStatus,
  ControlViolations,
} from '@repo/api-gw-sdk';

import { ControlViolationsTooltip } from '@/components/controls/controlIndicator';
import {
  ComplianceStatuses,
  ConfigurationStatuses,
} from '@/data/inventory/statusLooks';

import { ResourceStatusIcon } from './resourceStatusBadge';

// Both columns show the icon alone and name the status on hover, so a row reads as a row of
// indicators rather than three columns of prose competing with the resource name.

export const ConfigurationStatusBadge = ({
  status,
}: {
  status: ConfigurationStatus | undefined;
}) => {
  const look = status ? ConfigurationStatuses[status] : undefined;
  if (!look) {
    return null;
  }

  return (
    <Tooltip title={look.name}>
      <ResourceStatusIcon
        icon={look.icon}
        iconColor={look.iconColor}
        backgroundColor={look.backgroundColor}
      />
    </Tooltip>
  );
};

// The compliance verdict is a reading of the resource's violations, so its tooltip carries the same
// severity breakdown the backup status hangs off its own icon.
export const ComplianceStatusBadge = ({
  status,
  controlViolations,
}: {
  status: ComplianceStatus | undefined;
  controlViolations: ControlViolations | null | undefined;
}) => {
  const look = status ? ComplianceStatuses[status] : undefined;
  if (!look) {
    return null;
  }

  return (
    <ControlViolationsTooltip
      title={look.name}
      controlViolations={controlViolations}
    >
      <ResourceStatusIcon
        icon={look.icon}
        iconColor={look.iconColor}
        backgroundColor={look.backgroundColor}
      />
    </ControlViolationsTooltip>
  );
};
